import { onSignalREvent } from '../../signalRBus'
import { useAuthStore } from 'src/common/store'
import { SIGNAL_R_MESSAGES, SIGNAL_R_SCOPES } from 'src/signalR/types'
import { useMedicationStore } from 'src/stores/medication.store'

onSignalREvent(
  SIGNAL_R_SCOPES.system,
  SIGNAL_R_MESSAGES.getMedicationList,
  (text) => {
    const authStore = useAuthStore()
    const medicationStore = useMedicationStore()

    const centerId = text.split('_')[1]
    const localCenterId = authStore.currentCenterId
    if (localCenterId === centerId) {
      medicationStore.triggerMedicationListUpdate()
    }
  },
)
